import { EnhancedPaper } from 'summon-ui'
import { useTranslation } from 'summon-ui/intl'
import { Box, Flex, Title } from 'summon-ui/mantine'
import LeaderboardTable from '../components/LeaderboardTable'
// import { TENANT_CONFIG } from '@config'
import styles from './leaderboard.module.css'

export const TITLE = 'General'

const LeaderboardView = () => {
  const t = useTranslation()

  // const enableLeaderboardCampaigns = TENANT_CONFIG.features.enableLeaderboardCampaigns

  return (
    <Box className='h-full overflow-hidden'>
      <EnhancedPaper withBg classNames={{ root: styles.campaignsLeaderboardDescription }} p='lg'>
        <Flex align='center' justify='space-between' h='100%'>
          <Title data-testid='history-title-label' order={4}>
            {t(TITLE)}
          </Title>
        </Flex>
      </EnhancedPaper>
      <LeaderboardTable />
    </Box>
  )
  //  enableLeaderboardCampaigns ? (
  //   <Tabs defaultValue='general' h='100%'>
  //     <Stack className='h-full overflow-hidden' gap={0}>
  //       <Paper radius={0} h={70} classNames={{ root: styles.campaignsLeaderboardDescription }} withBorder>
  //         <EnhancedPaper withBg p='md' className='!rounded-t-xl'>
  //           <Flex align='center' justify='space-between' h='100%'>
  //             <Tabs.List>
  //               <Tabs.Tab value='general'>General</Tabs.Tab>
  //               <Tabs.Tab value='dungeons & degens'>Dungeons &amp; degens</Tabs.Tab>
  //             </Tabs.List>
  //           </Flex>
  //         </EnhancedPaper>
  //       </Paper>
  //       <Box className='h-[calc(100%-70px)]'>
  //         <Tabs.Panel value='general' h='100%'>
  //           <LeaderboardTable />
  //         </Tabs.Panel>
  //         <Tabs.Panel value='dungeons & degens' h='100%'>
  //           <LeaderboardTable campaignKey='dnd' />
  //         </Tabs.Panel>
  //       </Box>
  //     </Stack>
  //   </Tabs>
  // ) :
}

export default LeaderboardView
